export default "__VITE_ASSET__DbFi0hl8__"